import { Box, Tab, Tabs } from "@mui/material";
import React from "react";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabs({ tabs, orientation = 'horizontal', disabled = false }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className="custom-tabs-wrp">
            {!disabled &&
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs orientation={orientation} value={value} onChange={handleChange}>
                        {
                            tabs.map((tab, i) => <Tab label={tab.label} {...a11yProps(i)} />)
                        }
                    </Tabs>
                </Box>}
            {
                tabs.map((tab, i) => <TabPanel value={value} index={disabled ? value : i}>
                    {tab.component}
                </TabPanel>)
            }
        </div>
    );
};
export default CustomTabs;